import script from "./goRinSyo0037.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0037.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0037.vue?vue&type=style&index=0&id=e17eaad0&lang=scss"

const __exports__ = script;

export default __exports__